import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from "../firebase/firebaseConfig";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";

const Forms = () => {
  const [data, setData] = useState([]);
  
  useEffect(() => {
      const fetchFormsData = async () => {
          try {
          const querySnapshot = await getDocs(collection(db, "Forms"));
          const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setData(documents);
          } catch (error) {
          console.error("Error fetching data: ", error);
          }
      };
  
      fetchFormsData();
  }, []);

  return (
    <div id="content">
      <div className='row'>
        <div className='col-sm-6'>
          <h1>Forms Builder</h1>
          <h2 className='ev-sub-title'>Revival Church Montana</h2>
        </div>
        <div className='col-sm-6 calendar-buttons'>
          <div className='event-button'>
            <Link to="/create-a-form"><button>Create a Form</button></Link>
          </div>
        </div>
      </div>
      <br/>
        <div className="row">
          {data.map((item, index) => (
            <div className="col-sm-4 forms-box" key={index}>
              <h3 className="forms-title">{item.Title}</h3>
              <p className="forms-meta-data">Created: {item.Created.toDate().toLocaleDateString()}</p>
              <Link to={`/edit-form/${item.Title}`}>Edit Form</Link>
            </div>
          ))}
        </div>
    </div>
  );
}

export default Forms;
